import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FileSpecification } from 'src/app/models/file-specifications/file-specification';

export type FileSpecificationsSubTab = 'stills' | 'videos';

@Component({
  selector: 'app-file-specifications-panel',
  templateUrl: './file-specifications-panel.component.html',
  styleUrls: ['./file-specifications-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FileSpecificationsPanelComponent {
  @Input() fileSpecifications: FileSpecification[] = [];
  @Input() loaded = false;
  @Input() canWrite = false;
  @Input() canAudit = false;

  @Output() createStills = new EventEmitter<void>();
  @Output() createVideos = new EventEmitter<void>();
  @Output() updateFileSpecification = new EventEmitter<FileSpecification>();
  @Output() deleteFileSpecification = new EventEmitter<FileSpecification>();
  @Output() viewFileSpecificationHistory = new EventEmitter<FileSpecification>();

  activeSubTab: FileSpecificationsSubTab = 'stills';

  get stillsSpecs(): FileSpecification[] {
    return this.fileSpecifications.filter((row) => row.value.settings.media === 'stills');
  }

  get videosSpecs(): FileSpecification[] {
    return this.fileSpecifications.filter((row) => row.value.settings.media === 'videos');
  }

  onSubTabChanged(subTab: FileSpecificationsSubTab): void {
    this.activeSubTab = subTab;
  }

  onCreateStills(): void {
    this.createStills.emit();
  }

  onCreateVideos(): void {
    this.createVideos.emit();
  }

  onUpdateFileSpecification(row: FileSpecification): void {
    this.updateFileSpecification.emit(row);
  }

  onDeleteFileSpecification(row: FileSpecification): void {
    this.deleteFileSpecification.emit(row);
  }

  onViewFileSpecificationHistory(row: FileSpecification): void {
    this.viewFileSpecificationHistory.emit(row);
  }
}
